/** UI locales shipped in the app (i18n resources + preferred_language for children). */
export const UI_LANGUAGE_CODES = ['en', 'nl', 'fa', 'ar']

export const RTL_LANGUAGE_CODES = new Set(['fa', 'ar'])

export function isRtlLanguage(code) {
  const s = String(code ?? 'en')
    .split('-')[0]
    .toLowerCase()
  return RTL_LANGUAGE_CODES.has(s)
}

/** Short label on the language pill (avoid flex+truncate clipping “EN” into garbage on narrow layouts). */
export const UI_LANGUAGE_BADGE = {
  en: 'ENG',
  nl: 'NL',
  fa: 'FA',
  ar: 'AR',
}

/** labelKey = i18n key for native name shown in the language menu */
export const UI_LANGUAGES = [
  { code: 'en', labelKey: 'common.langEn' },
  { code: 'nl', labelKey: 'common.langNl' },
  { code: 'fa', labelKey: 'common.langFa' },
  { code: 'ar', labelKey: 'common.langAr' },
]
